'use client';

import ReactQRCode from 'react-qr-code';

import { styled } from '../../styles';
import { Button } from '../Button';
import { Typography } from '../Typography';

export const AppDownloaderHint = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  marginTop: theme.spacing(4),
}));

export const AppDownloaderQRContainer = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  margin: theme.spacing(7, 0),
}));

export const AppDownloaderTabContentQRCode = styled(ReactQRCode)(
  ({ theme }) => ({
    width: '190px',
    height: '190px',
    border: '4px solid white',
    borderRadius: theme.shape.borderRadius * 1.5,
  }),
);

export const AppDownloaderQrWhiteBorder = styled.div<{ isMain?: boolean }>(
  ({ isMain }) => ({
    width: '202px',
    height: '202px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#fff',
    borderRadius: '8px',
    padding: '6px',

    svg: {
      width: isMain ? '90%' : '100%',
      height: isMain ? '90%' : '100%',
    },
  }),
);

export const AppDownloaderButtonsContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const StyledAppDownloaderTabContent = styled.div(({ theme }) => ({
  padding: theme.spacing(4),
}));

export const AppDownloaderIconsContainer = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginInlineEnd: theme.spacing(2),
}));

export const AppDownloaderDownloadApkButton = styled(Button)(({ theme }) => ({
  ...(theme.direction === 'rtl' && {
    '& .MuiButton-startIcon': { marginLeft: theme.spacing(2) },
  }),
}));
